import * as ShareItemClickEvent from '@ori-events/share-item-click';

import { log } from './log';

export const triggerShareItemClickEvent = (detail: ShareItemClickEvent.Data) => {
  const customEvent = new CustomEvent<ShareItemClickEvent.Data>(ShareItemClickEvent.Name, {
    detail,
  });
  log(`Triggering custom event for analytics:`, customEvent);
  window.dispatchEvent(customEvent);
};
